module.exports = __webpack_public_path__ + "assets/73a8e7319f4a694349cd3f3ddb038876.vasterbotten-at-night.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/vasterbotten-at-night.png
 ** module id = 201
 ** module chunks = 1
 **/